import { useState } from 'react';

import { useUomsActions } from 'partsOld/hooks';
import { ICompanyPart, IUomForm } from 'partsOld/types';

import UomsTabView from './UomsTabView';

const WAITING_TIME = 500;

interface IProps {
  part: Partial<ICompanyPart>;
}

const UomsTab = ({ part }: IProps) => {
  const [isAddOpen, setIsAddOpen] = useState(false);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState<IUomForm>();
  const [removedItem, setRemovedItem] = useState<IUomForm>();

  const { removeUomConversion } = useUomsActions();

  const closeModal = (reset) => {
    setIsAddOpen(false);
    setSelectedItem(null);

    reset({ fromUom: '', toUom: '', multiplier: '' });
  };

  const onRemove = async (reset) => {
    try {
      if (removedItem) {
        await removeUomConversion({ ids: [removedItem?.id] });

        setSelectedItem(null);
        setTimeout(() => setRemovedItem(null), WAITING_TIME);

        return;
      }

      setRemovedItem(selectedItem);
      setSelectedItem(null);

      reset({ fromUom: '', toUom: '', multiplier: '' });
    } catch (err) {}
  };

  const onCancelRemove = () => {
    setSelectedItem(removedItem);
    setRemovedItem(null);
  };

  return (
    <UomsTabView
      part={part}
      isAddOpen={isAddOpen}
      setIsAddOpen={setIsAddOpen}
      closeModal={closeModal}
      isEditOpen={isEditOpen}
      setIsEditOpen={setIsEditOpen}
      selectedItem={selectedItem}
      setSelectedItem={setSelectedItem}
      onRemove={onRemove}
      onCancelRemove={onCancelRemove}
      removedItem={removedItem}
    />
  );
};

export default UomsTab;
